<template>
  <div class="delfhjl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.orderNum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发货包数"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#f56c6c">{{scope.row.num===999999999?1:scope.row.num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发货时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.orderaddress}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" @click.stop="detail(scope.row)" icon="el-icon-document">发货清单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="padding: 10px" v-loading="editloading">
        <div style="font-size: 13px">
          <span style="color:#99a9bf">发货人：</span>
          <span>{{oor.username}}</span>
          <span style="color:#99a9bf;margin-left: 20px">发货时间：</span>
          <span>{{oor.time}}</span>
          <span style="color:#99a9bf;margin-left: 20px">发货包数：</span>
          <span>{{oor.num===999999999?1:oor.num}}</span>
        </div>
        <div style="font-size: 12px;margin-top: 10px">
          <span style="color:#99a9bf">联系电话：</span>
          <span>{{oor.tel}}</span>
          <span style="color:#99a9bf;margin-left: 20px">送货地址：</span>
          <span>{{oor.address}}</span>
        </div>
        <div style="font-size: 12px;margin-top: 10px;margin-bottom: 10px">
          <span style="color:#99a9bf">备注：</span>
          <span>{{oor.remark}}</span>
        </div>
        <el-form :inline="true" size="small" :model="searchForm2" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchForm2.search" placeholder="关键字搜索" @keyup.enter.native="SearchData"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" @click="SearchData">搜索</el-button>
          </el-form-item>
        </el-form>
        <div style="width: 100%;height: 400px;" v-if="mealst.length>0">
          <pl-table
            :key="tableKey"
            height="400px"
            :datas="mealst"
            :data="mealst"
            use-virtual
            :pagination-show="false"
            size="small"
            :row-height="45">
            <pl-table-column prop="barCode" :resizable="false" align="center" fixed label="条码" show-overflow-tooltip width="130"></pl-table-column>
            <pl-table-column prop="xuhao" :resizable="false" align="center" fixed label="序号" show-overflow-tooltip width="80"></pl-table-column>
<!--            <pl-table-column prop="area" :resizable="false" align="center" label="区域" show-overflow-tooltip width="100"></pl-table-column>-->
<!--            <pl-table-column prop="type" :resizable="false" align="center" label="分类" show-overflow-tooltip width="80"></pl-table-column>-->
            <pl-table-column prop="name" :resizable="false" align="center" label="名称" show-overflow-tooltip min-width="130"></pl-table-column>
<!--            <pl-table-column prop="material" :resizable="false" align="center" label="基材" show-overflow-tooltip width="80"></pl-table-column>-->
            <pl-table-column :resizable="false" align="center" label="规格" show-overflow-tooltip width="130">
              <template slot-scope="scope">
                <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
              </template>
            </pl-table-column>
            <pl-table-column prop="color" :resizable="false" align="center" label="颜色" show-overflow-tooltipwidth="130"></pl-table-column>
            <pl-table-column prop="packnum" :resizable="false" align="center" fixed="right" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
            <pl-table-column prop="packxuhao" :resizable="false" align="center" fixed="right" label="包号" show-overflow-tooltip width="80"></pl-table-column>
          </pl-table>
        </div>
        <div style="margin-top: 10px" v-if="accessPackList.length>0">
          <div class="tcf-panel" v-for="pack in accessPackList">
            <p class="tcf-panel-header">
              <span><i class="el-icon-box"></i> {{pack.packnum}} <el-tag size="mini" :disable-transitions="true">配件</el-tag></span>
            </p>
            <div class="tcf-panel-body">
              <el-table
                :data="pack.oaodlst"
                style="width: 100%"
                stripe
                size="small">
                <el-table-column prop="xuhao" align="center" show-overflow-tooltip width="80" label="序号"></el-table-column>
                <el-table-column prop="area" label="区域" width="100" show-overflow-tooltip :resizable="false"></el-table-column>
                <el-table-column prop="type" align="center" show-overflow-tooltip width="90" label="分类"></el-table-column>
                <el-table-column prop="name" width="120" show-overflow-tooltip align="center" label="名称"></el-table-column>
                <el-table-column prop="material" align="center" show-overflow-tooltip width="90" label="基材"></el-table-column>
                <el-table-column label="规格" width="120" show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                    <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                    <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                    <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                    <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="num" align="center" show-overflow-tooltip width="80" label="数量"></el-table-column>
                <el-table-column prop="unit" align="center" show-overflow-tooltip width="60" label="单位"></el-table-column>
                <el-table-column prop="color" width="120" show-overflow-tooltip label="颜色" align="center"></el-table-column>
                <el-table-column prop="remark" min-width="100" show-overflow-tooltip label="备注" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="margin-right: 10px">
        <el-button icon="el-icon-printer" size="small" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button icon="el-icon-printer" size="small" :loading="printLoading" @click="printFhqd" >打印发货清单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerDeliveryRecord, getDealerDeliveryRecordDetail, exportDeliveryRecordDetail } from '@/api/dealer'
import { getLodop } from '@/common/Lodop/LodopFuncs'
import { printShippingList } from '@/api/erp'

export default {
  name: 'delfhjl',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      searchForm2: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editTitle: '',
      editVisible: false,
      orderid: '',
      oor: [],
      mealst: [],
      editloading: false,
      tableKey: '',
      accessPackList: [],
      exportLoading: false,
      printLoading: false,
      packlst: [],
      oorid: null,
      accessPackListData: [],
      mealstData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    SearchData() {
      if (this.searchForm2.search !== null && this.searchForm2.search.trim() !== '') {
        let _search = this.searchForm2.search + ''
        this.mealst = []
        this.accessPackList = []
        for (let m of this.mealstData) {
          if ((m.barCode + '').indexOf(_search) >= 0 || (m.xuhao + '').indexOf(_search) >= 0 || (m.name + '').indexOf(_search) >= 0 || (m.color + '').indexOf(_search) >= 0 || (m.packnum + '').indexOf(_search) >= 0 || (m.packxuhao + '').indexOf(_search) >= 0) {
            this.mealst.push(m)
          }
        }
        for (let a of this.accessPackListData) {
          let _isadd = false
          let _oaodlst = []
          for (let b of a.oaodlst) {
            if ((b.xuhao + '').indexOf(_search) >= 0 || (b.area + '').indexOf(_search) >= 0 || (b.type + '').indexOf(_search) >= 0 || (b.name + '').indexOf(_search) >= 0 || (b.material + '').indexOf(_search) >= 0 || (b.unit + '').indexOf(_search) >= 0 || (b.color + '').indexOf(_search) >= 0 || (b.remark + '').indexOf(_search) >= 0) {
              _oaodlst.push(b)
              _isadd = true
            }
          }
          if (_isadd) {
            this.accessPackList.push({
              id: a.id,
              num: a.num,
              oorid: a.oorid,
              packnum: a.packnum,
              oaodlst: _oaodlst
            })
          }
        }
      } else {
        this.mealst = this.mealstData
        this.accessPackList = this.accessPackListData
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid
      }
      getDealerDeliveryRecord(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delorder/' + row.orderid })
    },
    detail(row) {
      if (row.bid === 3) {
        this.editTitle = row.orderNum + ' 发货清单'
      } else {
        this.editTitle = row.produnum + ' 发货清单'
      }
      this.accessPackList = []
      this.mealst = []
      this.tableKey = new Date().getTime()
      this.editVisible = true
      this.editloading = true
      this.oorid = row.oorid
      this.orderid = row.orderid
      getDealerDeliveryRecordDetail({ oorid: row.oorid }).then(response => {
        this.editloading = false
        this.oor = response.data.oor
        this.mealst = response.data.mealst
        this.accessPackList = response.data.accessPackList
        this.packlst = response.data.packlst
        this.accessPackListData = response.data.accessPackList
        this.mealstData = response.data.mealst
        this.searchForm2.search = ''
      }).catch(() => {
        this.editloading = false
        this.mealst = []
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          oorid: this.oorid,
          tableName: '发货清单'
        }
        exportDeliveryRecordDetail(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    printFhqd() {
      if (this.packlst.length > 0 || this.accessPackList.length > 0) {
        if (!this.printLoading) {
          const LODOP = getLodop()
          if (LODOP !== null && LODOP !== undefined) {
            this.printLoading = true
            let packids = []
            for (let p of this.packlst) {
              packids.push(p.packid)
            }
            let mdids = []
            for (const a of this.accessPackList) {
              for (const d of a.oaodlst) {
                mdids.push(d.mdid)
              }
            }
            const data = {
              orderid: this.orderid,
              packids: packids.join(','),
              mdids: mdids.join(',')
            }
            printShippingList(data).then(response => {
              LODOP.PRINT_INIT('出库清单打印')
              LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
              LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
              LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
              LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
              LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
              LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
              LODOP.NewPageA()
              LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
              LODOP.PREVIEW()
              this.printLoading = false
            }).catch(() => {
              this.printLoading = false
            })
          }
        }
      } else {
        this.$message.error('无出库包装打印')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.delfhjl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
